(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amazon-bundle-help"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amazon-help-faq')) {
    customElements.define('amazon-help-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !this.contains(summary)) return;
          event.preventDefault();
          const details = summary.parentElement;
          const answer = details.querySelector('.whalebud-amazon-help__answer');
          const opening = !details.open || details.classList.contains('is-closing');
          const height = details.getBoundingClientRect().height;
          const opacity = details.open ? getComputedStyle(answer).opacity : 0;
          details.getAnimations().forEach((animation) => animation.cancel());
          answer.getAnimations().forEach((animation) => animation.cancel());
          details.classList.toggle('is-closing', !opening);
          details.open = true;
          const targetHeight = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderBottomWidth);
          const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
          details.style.overflow = 'hidden';
          const animation = details.animate([{ height: height + 'px' }, { height: targetHeight + 'px' }], { duration, easing: 'ease' });
          const fade = answer.animate([{ opacity }, { opacity: opening ? 1 : 0 }], { duration, easing: 'ease', fill: 'forwards' });
          animation.onfinish = () => {
            details.open = opening;
            details.classList.remove('is-closing');
            details.style.overflow = '';
            fade.cancel();
          };
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amazon-bundle-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amazon-proof-slider')) {
    customElements.define('amazon-proof-slider', class extends HTMLElement {
      connectedCallback() {
        const initialize = () => {
          if (!this.isConnected) return;
          if (typeof Swiper === 'undefined') { this.timer = setTimeout(initialize, 100); return; }
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.carousel = new Swiper(this, {
            centeredSlides: true,
            initialSlide: Number(this.dataset.initialSlide) || 0,
            loop: this.querySelectorAll('.swiper-slide').length > 2,
            slidesPerView: 'auto',
            spaceBetween: matchMedia('(max-width: 768px)').matches ? -8 : -18,
            speed: reducedMotion ? 0 : 500,
            autoplay: reducedMotion ? false : { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
            grabCursor: true,
            simulateTouch: true,
            touchEventsTarget: 'container',
            slideToClickedSlide: true,
            on: {
              init: () => { this.updateSlideStates(); this.restartProgress(); },
              slideChangeTransitionStart: () => { this.updateSlideStates(); this.restartProgress(); },
              resize: () => this.updateSlideStates()
            }
          });
          this.previousButton = this.querySelector('.whalebud-amazon-proof__arrow--prev');
          this.nextButton = this.querySelector('.whalebud-amazon-proof__arrow--next');
          this.onPrevious = (event) => { event.preventDefault(); this.carousel.slidePrev(); };
          this.onNext = (event) => { event.preventDefault(); this.carousel.slideNext(); };
          if (this.previousButton) this.previousButton.addEventListener('click', this.onPrevious);
          if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
          requestAnimationFrame(() => { this.carousel.update(); this.updateSlideStates(); });
        };
        initialize();
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('.swiper-slide');
          if (!slide || !this.carousel) return;
          const index = Number(slide.dataset.swiperSlideIndex);
          if (Number.isInteger(index)) this.carousel.slideToLoop(index);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      updateSlideStates() {
        if (!this.carousel) return;
        const originals = this.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
        const active = this.carousel.realIndex;
        this.querySelectorAll('.swiper-slide').forEach((slide, fallbackIndex) => {
          const rawIndex = slide.dataset.swiperSlideIndex;
          const index = rawIndex === undefined ? fallbackIndex : Number(rawIndex);
          let distance = index - active;
          if (originals > 2) {
            if (distance > originals / 2) distance -= originals;
            if (distance < -originals / 2) distance += originals;
          }
          slide.dataset.proofDistance = Math.max(-3, Math.min(3, distance));
        });
      }
      restartProgress() {
        const button = this.querySelector('.whalebud-amazon-proof__arrow--next');
        if (!button || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        button.classList.remove('is-timing');
        void button.offsetWidth;
        button.classList.add('is-timing');
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.previousButton) this.previousButton.removeEventListener('click', this.onPrevious);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        if (this.carousel) this.carousel.destroy(true, true);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
